import Swiper from 'swiper';
import {Autoplay, EffectFade} from 'swiper/modules';
import initializeRepairForm from './../repair-form/_form';

function initializeMainVisualSection() {
  new Swiper('.main-image .swiper', {
    modules: [Autoplay, EffectFade],
    speed: 2000,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: true
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
  });
}

function initializeWorriesSection() {
  const button = document.querySelector('.btn-worries');

  button.addEventListener('click', () => {
    $(button).next().slideToggle();
    button.classList.toggle('active');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeMainVisualSection();
  initializeWorriesSection();
  initializeRepairForm(document.querySelector('form.repair-form'));
});
